<script lang="ts">
  import { FileText } from 'lucide-svelte';
  import type { DocumentCatalogEntry } from '../api';
  import { formatDate } from '../settings';
  import { userSettings } from '../stores/settingsStore';

  export let doc: DocumentCatalogEntry;
  export let fallbackLabel: string = '';
  export let onClick: () => void;
</script>

<button
  class="flex items-center gap-2 w-full text-left py-1 px-2 hover:bg-accent/10 rounded text-xs group transition-colors"
  on:click={onClick}
>
  <FileText class="w-3 h-3 text-text-muted" strokeWidth={1.5} />
  <span class="truncate text-text group-hover:text-accent">{doc.displayName || doc.fileName}</span>
  <span class="text-[10px] text-text-muted ml-auto whitespace-nowrap">
    {#if doc.referenceDate}{formatDate(
        doc.referenceDate,
        $userSettings,
      )}{:else if fallbackLabel}{fallbackLabel}{/if}
  </span>
</button>
